import { ModalWindow, RefString, RefJsonViewer, Button } from "@tblabs/truffle";
import { ConnectionStatus } from "../Models/DeviceConnectionStatus";
import { WatcherProfile } from "../Models/WatcherProfile";
import { Server } from "../Services/Server";


export class AllWatchersWindow extends ModalWindow
{
    constructor(_server: Server)
    {
        super(`All Watchers`, true, true, true);

        const watchersAsString = new RefString();

        this.AddContent(
            new RefJsonViewer(watchersAsString)
        );
        this.footer.TextAlignLeft();
        this.AddToFooter(
            new Button("Refresh").Class("uk-button uk-button-primary")
                .OnClick(() =>
                {
                    this.GetWatchers(_server, watchersAsString);
                })
        );

        this.GetWatchers(_server, watchersAsString);
        this.OpenWindow();
    }

    private GetWatchers(_server: Server, watchersAsString: RefString)
    {
        _server.Request("get-watchers", [],
            (watchers: WatcherProfile[]) =>
            {
                // Group watchers by TrackedDeviceId
                const grouped: Record<string, WatcherProfile[]> = watchers.reduce((acc, watcher) =>
                {
                    const deviceStatus = watcher.TrackedDeviceStatus == ConnectionStatus.Connected ? "🟢" : "⚪";
                    const deviceId = deviceStatus + " " + watcher.TrackedDeviceId;
                    if (!acc[deviceId])
                    {
                        acc[deviceId] = [];
                    }
                    acc[deviceId].push(watcher);
                    return acc;
                }, {});

                watchersAsString.value = JSON.stringify(grouped);
            }, (error) =>
            {
                console.error(error);
            });
    }
}
